












import { defineComponent, ref } from "@vue/composition-api";
import providers from "@/lib/api";
import BaseButton from "@/components/BaseButton";
import BaseConfirm from "@/components/BaseConfirm";

export default defineComponent({
  name: "GroupDeleteConfirmation",
  components: { BaseConfirm, BaseButton },
  props: {
    show: { type: Boolean, required: true },
    groupId: { type: String, required: true },
  },
  setup(props, { emit }) {
    const loading = ref(false);
    const deleteGroup = async () => {
      loading.value = true;
      const result = await providers.GroupsProvider.delete(props.groupId);
      if (result) {
        emit("close");
        emit("delete", props.groupId);
      }
      loading.value = false;
    };

    return { loading, deleteGroup };
  },
});
